var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67714 11.4536C12.8013 16.7415 20.4167 26.5415 20.4167 26.5415V38.7915C20.4167 39.9144 21.3355 40.8332 22.4584 40.8332H26.5417C27.6646 40.8332 28.5834 39.9144 28.5834 38.7915V26.5415C28.5834 26.5415 36.1784 16.7415 40.3026 11.4536C41.3438 10.1061 40.3842 8.1665 38.6896 8.1665H10.2901C8.59548 8.1665 7.63589 10.1061 8.67714 11.4536Z",
    fill: "#6695F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4faaa17364b73fb26f67b96d652bfb4a.svg";
export { ForwardRef as ReactComponent };